<!DOCTYPE html>
<html lang="nb">
  <head>
    <meta charset="utf-8" />
    <link
      rel="icon"
      href="https://bbldthemesprod.blob.core.windows.net/theme/bbld/favicon.ico"
    />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#ffffff" />
    <meta name="apple-mobile-web-app-status-bar-style" content="default" />

    <meta
      http-equiv="Content-Security-Policy"
      content="
        script-src 'self' 'unsafe-eval' blob: https://www.googletagmanager.com https://maps.googleapis.com https://*.google-analytics.com https://*.cookie-script.com;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://unpkg.com/react-day-picker@9.5.0/src/style.css https://bbldthemestest.blob.core.windows.net https://bbldthemesstage.blob.core.windows.net https://bbldthemesprod.blob.core.windows.net;
      font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com https://bbldthemestest.blob.core.windows.net https://bbldthemesstage.blob.core.windows.net https://bbldthemesprod.blob.core.windows.net;"
    />

    <link
      href="https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap"
      rel="stylesheet"
    />

    <link
      href="https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap"
      rel="stylesheet"
    />

    <script type="text/javascript" src="/config/appconfig.js"></script>
    <script type="text/javascript" src="/config/clientId.js"></script>
    <script type="text/javascript" src="/config/bblCode.js"></script>

    <!--
      Notice the use of %PUBLIC_URL% in the tags above.
      It will be replaced with the URL of the `public` folder during the build.
      Only files inside the `public` folder can be referenced from the HTML.

      Unlike "/favicon.ico" or "favicon.ico", "%PUBLIC_URL%/favicon.ico" will
      work correctly both with client-side routing and a non-root public URL.
      Learn how to configure a non-root public URL by running `npm run build`.
    -->
    <title>Portalen</title>
  </head>
  <body>
    <noscript>You need to enable JavaScript to run this app.</noscript>
    <div id="root"></div>
    <!--
      This HTML file is a template.
      If you open it directly in the browser, you will see an empty page.

      You can add webfonts, meta tags, or analytics to this file.
      The build step will place the bundled scripts into the <body> tag.

      To begin the development, run `npm start` or `yarn start`.
      To create a production bundle, use `npm run build` or `yarn build`.
    -->
    <script type="module" src="/src/index.tsx"></script>
  </body>
</html>
